import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ChatDebugInit = {
  apologyCount: number;
  generatedCorrectedQueryCount: number;
  runCorrectedQueryCount: number;
  lastCorrectedQuery: string;
  attempts: string[];
  lastQuery: string;
};

const initialState: ChatDebugInit = {
  apologyCount: 0,
  generatedCorrectedQueryCount: 0,
  runCorrectedQueryCount: 0,
  lastCorrectedQuery: '',
  attempts: [],
  lastQuery: '',
};

export const chatDebugSliceName = 'chatDebug';

export const chatDebugSlice = createSlice({
  name: chatDebugSliceName,
  initialState,
  reducers: {
    reset: (state) => {
      state.attempts = [];
      state.apologyCount = 0;
      state.generatedCorrectedQueryCount = 0;
      state.runCorrectedQueryCount = 0;
      state.lastCorrectedQuery = '';
      state.lastQuery = '';
    },
    updateAttempts: (state, action: PayloadAction<string>) => {
      state.attempts.push(action.payload);
    },
    updateLastQuery: (state, action: PayloadAction<string>) => {
      state.lastQuery = action.payload;
    },
    updateLastCorrectedQuery: (state, action: PayloadAction<string>) => {
      state.lastCorrectedQuery = action.payload;
    },
    incrementApologyCount: (state) => {
      state.apologyCount += 1;
    },
    incrementGeneratedCorrectedQueryCount: (state) => {
      state.generatedCorrectedQueryCount += 1;
    },
    incrementRunCorrectedQueryCount: (state) => {
      state.runCorrectedQueryCount += 1;
    },
  },
});

export const {
  reset,
  updateAttempts,
  updateLastQuery,
  updateLastCorrectedQuery,
  incrementApologyCount,
  incrementGeneratedCorrectedQueryCount,
  incrementRunCorrectedQueryCount,
} = chatDebugSlice.actions;

export default chatDebugSlice.reducer;
